import { Injectable, OnDestroy, signal, WritableSignal, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { BankingDetails } from '../../_interfaces/business.interface';
import { BusinessApiService } from './business-api.service';

@Injectable({
  providedIn: 'root',
})
export class BusinessService implements OnDestroy {
  readonly businessApiService = inject(BusinessApiService);

  readonly subscriptions = new Subscription();
  public bankingDetails: WritableSignal<BankingDetails | null> = signal(null);

  fetchBankingDetails() {
    this.subscriptions.add(
      this.businessApiService.getBankingDetails().subscribe((data: BankingDetails) => {
        this.bankingDetails.set(data);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
